<template>
  <el-tabs v-model="activeName" @tab-click="handleClick">
    <el-tab-pane label="欠费中" name="first">
      <arrears-list></arrears-list>
    </el-tab-pane>
    <el-tab-pane label="冲销中" name="second">
      <arrear-cancel-applying></arrear-cancel-applying>
    </el-tab-pane>
    <el-tab-pane label="已冲销" name="third">
      <arrear-cancel-approved></arrear-cancel-approved>
    </el-tab-pane>
  </el-tabs>
</template>
<script>
import ArrearsList from "./arrearsList.vue";
import ArrearCancelApplying from "./ArrearCancelApplying.vue";
import ArrearCancelApproved from "./ArrearCancelApproved.vue";
export default {
  data() {
    return {
      activeName: "first",
      searchParams: {
        carNumber: "",
        entryDate: [],
      },
    };
  },
  components: {
    ArrearsList,
    ArrearCancelApplying,
    ArrearCancelApproved,
  },
  methods: {
    handleClick(tab, event) {
      // console.log(tab, event);
    },
  },
  provide: function() {
    return {
      searchParams: this.searchParams,
    };
  },
  // mounted: function() {
  //   console.log('mounted arrearsListTab ')
  //   if (Object.keys(this.$route.query).length === 0) return;
  //   this.searchParams.carNumber = this.$route.query.carNumber;
  //   this.searchParams.entryDate = this.$route.query?.crtTime?.split("~") ?? [];
  // },
  activated() {
   
    if (Object.keys(this.$route.query).length === 0) return;
    this.searchParams.carNumber = this.$route.query.carNumber;
    this.searchParams.entryDate = this.$route.query?.crtTime?.split("~") ?? [];
  
  },
};
</script>
<style>
.el-tabs__header {
  margin: 0 0 0 20px;
}
.el-tabs__content {
  overflow: auto;
  height: 100%;
  position: static;
}
</style>
